<template>
    <div>
        <card-header title="Hotel" icon="fa-hotel"/>

        <entity-tabs v-model="tab" main-label="Hotel" main-icon="fa-hotel" show-contacts :contact-count="contactCount" :task-count="taskCount" :task-completed-count="taskCompleted" :note-count="noteCount"/>

        <card-toolbar v-show="tab === 'main'">
            <button @click="$openCard('edit-trip-hotel', {hotelId: hotel.id, tripId: hotel.trip_id}, card)"><i class="fas fa-pencil mr-2"/>Edit Hotel</button>
            <button @click="$openCard('new-room-type', {hotelId: hotel.id, tripId: hotel.trip_id}, card)"><i class="fas fa-plus mr-2"/>New Room Type</button>
        </card-toolbar>

        <card-body>
            <entity-contacts-pane v-show="tab === 'contacts'" :card="card" :child="child" entity-type="trip-hotels" :entity-id="props.hotelId" @count="contactCount = $event"/>
            <entity-tasks-pane v-show="tab === 'tasks'" :card="card" :child="child" entity-type="trip-hotels" :entity-id="props.hotelId" @count="taskCount = $event" @completed="taskCompleted = $event"/>
            <entity-notes-pane v-show="tab === 'notes'" :card="card" :child="child" entity-type="trip-hotels" :entity-id="props.hotelId" @count="noteCount = $event"/>
            <card-list v-show="tab === 'main'">
                <subheader-list-item title="Hotel Details" icon="fa-list"/>
                <data-row title="Name">{{ hotel.title }}</data-row>
                <data-row title="Location">{{ hotel.location }}</data-row>
                <data-row title="Phone" v-if="hotel.phone">{{ hotel.phone }}</data-row>
                <data-row title="Website" v-if="hotel.website">{{ hotel.website }}</data-row>
                <!-- Contact rows moved to the Contacts tab above. -->
                <data-row title="Default Check-In" v-if="hotel.default_start_date || hotel.default_start_time">{{ formatDefault(hotel.default_start_date, hotel.default_start_time, hotel.default_start_tz) }}</data-row>
                <data-row title="Default Check-Out" v-if="hotel.default_end_date || hotel.default_end_time">{{ formatDefault(hotel.default_end_date, hotel.default_end_time, hotel.default_end_tz) }}</data-row>
                <data-row title="Notes" v-if="hotel.notes">{{ hotel.notes }}</data-row>

                <separator-list-item/>

                <subheader-list-item title="Room Types" icon="fas fa-bed"/>

                <draggable v-model="hotel.room_types" handle=".drag-handle" @end="completeDrag">
                    <transition-group>
                        <trip-room-type-list-item
                            :card="card"
                            :room="room"
                            :key="room.id"
                            :active="(child && child.definition.component === 'edit-room-type') && child.props.answerId === room.id.toString()"
                            @click="$openCard('edit-room-type', {tripId: hotel.trip_id, hotelId: hotel.id, roomId: room.id}, card)"
                            v-for="room in hotel.room_types"
                            class="t-card-list-item"
                        />
                    </transition-group>
                </draggable>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import TripListItem from "@/components/TripListItem";

    import draggable from 'vuedraggable';
    import moment from 'moment-timezone';

    import {client as http} from '@/http_client';
    import CardBody from "@/TIER/components/CardBody";
    import DayListItem from "@/components/DayListItem";
    import TripAddOnListItem from "@/components/TripAddOnListItem";
    import QuestionListItem from "@/components/QuestionListItem";
    import DataRow from "@/TIER/components/DataRow";
    import AnswerListItem from "@/components/AnswerListItem";
    import TripRoomTypeListItem from "@/components/TripRoonTypeListItem";
    import EntityTabs from "@/components/EntityTabs";
    import EntityTasksPane from "@/components/EntityTasksPane";
    import EntityContactsPane from "@/components/EntityContactsPane";
    import EntityNotesPane from "@/components/EntityNotesPane";

    export default {
        name: "RegistrationQuestions",
        props: ['card', 'child', 'props'],
        components: {EntityContactsPane, EntityNotesPane, EntityTasksPane, EntityTabs, TripRoomTypeListItem, draggable, AnswerListItem, DataRow, QuestionListItem, TripAddOnListItem, CardBody, TripListItem, NavigationListItem, SeparatorListItem, SubheaderListItem, SearchListItem, CardToolbar, CardList, CardHeader},
        data: function() {
            return {
                tab: 'main',
                contactCount: 0,
                taskCount: 0,
                taskCompleted: 0,
                noteCount: 0,
                hotel: {
                    responses: []
                }
            };
        },
        methods: {
            loadHotel: function(force) {
                this.$emit('loading', true);
                http.get('/api/trips/' + this.props.tripId + '/hotels/' + this.props.hotelId, {force}).then(response => {
                    this.hotel = response.data;
                    this.$emit('loading', false);
                });
            },
            formatDefault: function(date, time, tz) {
                let parts = [];
                if (date) parts.push(moment(date).format('MMM Do, YYYY'));
                if (time) parts.push(moment(time, 'HH:mm').format('h:mm A'));
                return parts.join(', ') + (tz ? ' (' + tz + ')' : '');
            },
            completeDrag: function() {
                http.post('/api/trips/'  + this.props.tripId + '/hotels/' + this.props.hotelId + '/order', this.hotel.room_types.map(p => p.id)).then(response => {

                });
            },
            reload: function() {
                this.loadHotel(true);
            }
        },
        watch: {
            'props.hotelId': function() {
                this.loadHotel(true);
            }
        },
        mounted() {
            this.loadHotel(true);
        }
    };
</script>

<style lang="scss" scoped>

</style>
